// 全部
const ALL_COUNTROY_TOTAL = "総数"
const ALL_COUNTROY = [
    ALL_COUNTROY_TOTAL
]

// アジア州
const ASIA_TOTAL = "計"
const ASIA_KOREA = "韓国・朝鮮"
const ASIA_CHINA = "中国"
const ASIA_IRAN = "イラン"
const ASIA_INDIA = "インド"
const ASIA_INDONESIA = "インドネシア"
const ASIA_SRI_LANKA = "スリランカ"
const ASIA_THAILAND = "タイ"
const ASIA_PAKISTAN = "パキスタン"
const ASIA_BANGLADESH = "バングラデシユ"
const ASIA_PHILIPPINES = "フイリピン"
const ASIA_VIETNAM = "ベトナム"
const ASIA_MALAYSIA = "マレーシア"
const ASIA_OTHERS = "その他"
const ASIA_COUNTROY = [
    ASIA_TOTAL,
    ASIA_KOREA,
    ASIA_CHINA,
    ASIA_IRAN,
    ASIA_INDIA,
    ASIA_INDONESIA,
    ASIA_SRI_LANKA,
    ASIA_THAILAND,
    ASIA_PAKISTAN,
    ASIA_BANGLADESH,
    ASIA_PHILIPPINES,
    ASIA_VIETNAM,
    ASIA_MALAYSIA,
    ASIA_OTHERS,    
]


// ヨーロッパ州
const EUROPE_TOTAL = "計"
const EUROPE_UK = "イギリス"
const EUROPE_ITALY = "イタリア"
const EUROPE_GERMANY = "ドイツ"
const EUROPE_FRANCE = "フランス"
const EUROPE_RUSSIA = "ロシア"
const EUROPE_OTHERS = "その他"
const EUROPE_COUNTROY = [
    EUROPE_TOTAL,
    EUROPE_UK,
    EUROPE_ITALY,
    EUROPE_GERMANY,
    EUROPE_FRANCE,
    EUROPE_RUSSIA,
    EUROPE_OTHERS,
]


// 南北アメリカ州
const AMERICAS_TOTAL = "計"
const AMERICAS_USA = "アメリカ"
const AMERICAS_CANADA = "カナダ"
const AMERICAS_BRAZIL = "ブラジル"
const AMERICAS_OTHERS = "その他"
const AMERICAS_COUNTROY = [
    AMERICAS_TOTAL,
    AMERICAS_USA,
    AMERICAS_CANADA,
    AMERICAS_BRAZIL,
    AMERICAS_OTHERS,
]

// アフリカ州
const AFRICA_TOTAL = "計"
const AFRICA_COUNTROY = [
    AFRICA_TOTAL,
]

// オセアニア州
const OCEANIA_TOTAL = "計"
const OCEANIA_COUNTROY = [
    OCEANIA_TOTAL,
]


// 無国籍	計
const STATELESS_TOTAL = "計"
const STATELESS_COUNTROY = [
    STATELESS_TOTAL,
]


// 国籍不明	計
const UNKNOWN_NATIONALITY_TOTAL = "計"
const UNKNOWN_COUNTROY = [
    UNKNOWN_NATIONALITY_TOTAL,
]

export const ALL_COUNTROY_DICT = {
    "全世界" : ALL_COUNTROY,
    "アジア州" : ASIA_COUNTROY,
    "ヨーロッパ州" : EUROPE_COUNTROY,
    "南北アメリカ州" : AMERICAS_COUNTROY,
    "アフリカ州" : AFRICA_COUNTROY,
    "オセアニア州" : OCEANIA_COUNTROY,
    "無国籍" : STATELESS_COUNTROY,
    "国籍不明" : UNKNOWN_COUNTROY,      
}